import { appEnv } from '../config/env';
import { cmsSession } from '../services/centralAuth';

export function cmsSettingsAccess(siteId: string | null = localStorage.getItem(appEnv.storageCurrentSiteKey)) {
  const site = cmsSession()?.context.workspaces.find(workspace => workspace.businessId === siteId);
  return {
    site,
    canManageBilling: site?.canManageBilling === true,
    isSiteOwner: site?.role === 1,
  };
}
